import type { EuMaxTaxExposureDto } from '@b-stock/listing-api-client'

import euTaxMaxExposureQuery from '@/queries/euTaxMaxExposureQuery'

// Bid-confirmation counterpart to `useEuRunningVatEstimate`. The
// endpoint is ACTIVE_BUYER, so `buyerAddressId` is effectively required
// upstream (FR-008 gates bidding on a valid address).
//
// Suppression mirrors `useMaxTaxExposure`:
//   - `isTaxable` false / no address / no bid → skip the request.
//   - react-query error → return `undefined`.
//   - `estimateUnavailable: true` is passed through — the display renders
//     the unavailable state rather than €0.00 (FR-020).
const useEuMaxVatExposure = ({
  isTaxable = true,
  listingId,
  formSingleBid,
  buyerAddressId,
  formProxyMaxBid,
  buyerFeeCents,
  shippingCents,
}: {
  isTaxable?: boolean
  listingId: string
  formSingleBid: number
  buyerAddressId: string | undefined
  formProxyMaxBid?: number
  buyerFeeCents?: number
  shippingCents?: number
}): EuMaxTaxExposureDto | undefined => {
  const { data, isError } = euTaxMaxExposureQuery.useWithOpts(
    [
      listingId,
      formSingleBid,
      buyerAddressId ?? '',
      formProxyMaxBid,
      buyerFeeCents,
      shippingCents,
    ],
    {
      enabled: isTaxable && Boolean(buyerAddressId) && formSingleBid > 0,
    }
  )

  if (!isTaxable || !buyerAddressId || isError || !data) {
    return undefined
  }

  return data
}

export default useEuMaxVatExposure
